export * from './angularfire2';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// D:/ThinkBIT/work-projects/confe/hosting/~/angularfire2/public_api.js
// module id = ../../../../angularfire2/public_api.js
// module chunks = 22